<template>
  <input
    ref="inputRef"
    class="form-control form-control-sm"
    autocomplete="off"
    type="tel"
    v-bind="$attrs"
  />
</template>

<script>
import { useCurrencyInput } from "vue-currency-input";

export default {
  name: "CurrencyInput",
  props: {
    modelValue: Number, // Vue 2: value
  },
  setup(props) {
    const { inputRef } = useCurrencyInput({
      locale: "en-US",
      currency: "USD",
      currencyDisplay: "hidden",
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: true,
      autoDecimalDigits: false,
      useGrouping: true,
      accountingSign: false,
    });

    return { inputRef };
  },
};
</script>
